module.exports = __webpack_public_path__ + "img/no.88ed57af.png";